import { AlertTriangle } from "lucide-react";
import type { MaintenanceWindow } from "../types";

interface Props {
  active: MaintenanceWindow;
}

export function MaintenanceDeploymentActiveBanner({ active }: Props) {
  const endsAt = new Date(active.ends_at);
  const endsLabel = endsAt.toLocaleTimeString("pl-PL", { hour: "2-digit", minute: "2-digit" });

  return (
    <div className="w-full bg-amber-500 text-amber-950 text-xs font-mono py-1.5 px-4 flex items-center gap-2 z-50 flex-shrink-0">
      <AlertTriangle size={14} className="flex-shrink-0" />
      <span className="font-semibold">Trwa wdrożenie nowej wersji</span>
      <span className="opacity-80">— mogą wystąpić chwilowe zakłócenia (do ok. {endsLabel})</span>
      {active.message && (
        <span className="hidden sm:inline opacity-80 truncate">| {active.message}</span>
      )}
    </div>
  );
}
